import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router } from "@angular/router";
import { IfirmTaxCardsService } from "@shared/ifirm-tax-cards-service";

export const cardAvailabilityGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
    const ifirmTaxCardsService = inject(IfirmTaxCardsService);
    const router = inject(Router);

    const cardId = route.params.cardId as string;

    await ifirmTaxCardsService.waitForDocuments();

    return ifirmTaxCardsService.isCardAvailable(cardId) ? true : router.createUrlTree(["/card-view"]);
};
